module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADlSURBVHgBjVMLEYMwDE0dbAqohErYFIwpAAdIoA4mYRKYAyTspoA5YA665EhGmgPGu3tHfy/JSwuAQUqpRvbIMU0YeV7Zs06JPH465Af5YBKOyIBseX52zr11No8ckC1sgPb5nNeLf4UmwFN7HHaIvPj+9WCtGUZ4omxSLn4b0gF3M2wIa+uTqxiBr6NQG6UaB94vFywkyVyoZhCiuoH7QjVBMvfkgRcPyC7NyMo1Vvp5kG/eWLzYSA5ayYQ6Gc2BZkUYs6tV/iJsQIRixb5tKZ+CvGB654QLkjp+QF6zt22i7/6rvmgXUQd0vq12AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certification4.png
// module id = r7Ru
// module chunks = 1